import React from 'react';

import cx from 'classnames';

import { Container, ResponsiveBackground } from '@nord/ui';

import './index.scss';

export interface IErrorPageProps extends React.HTMLAttributes<HTMLDivElement> {
  outerClassName?: string;
  contentClassName?: string;
  status?: React.ReactNode;
  statusWrapClassName?: string;
  heading?: React.ReactNode;
  headingWrapClassName?: string;
  background?: Record<string, any>;
}

const ErrorPage: React.FC<IErrorPageProps> = ({
  className,
  children,
  outerClassName,
  contentClassName,
  status,
  statusWrapClassName,
  heading,
  headingWrapClassName,
  background,
}) => (
  <ResponsiveBackground className={cx('ErrorPage', className)} {...background}>
    <div className={cx('ErrorPage__Outer', outerClassName)}>
      <Container>
        <div className="ErrorPage__Inner">
          {status && <div className={cx('ErrorPage__Status', statusWrapClassName)}>{status}</div>}
          {heading && (
            <div className={cx('ErrorPage__Heading', headingWrapClassName)}>{heading}</div>
          )}
          {children && <div className={cx('ErrorPage__Content', contentClassName)}>{children}</div>}
        </div>
      </Container>
    </div>
  </ResponsiveBackground>
);

export default ErrorPage;
